import { render, staticRenderFns } from "./WrkAgentView.vue?vue&type=template&id=25657825&scoped=true"
import script from "./WrkAgentView.vue?vue&type=script&lang=js"
export * from "./WrkAgentView.vue?vue&type=script&lang=js"
import style0 from "./WrkAgentView.vue?vue&type=style&index=0&id=25657825&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25657825",
  null
  
)

export default component.exports